import deviceTypes from './modules/device/types';
import facemappingTypes from './modules/facemapping/types';

export default {
    ...deviceTypes,
    ...facemappingTypes
};
